module.exports = __webpack_public_path__ + "img/lelin-logo.04fb9833.png";